///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	languagesManagerActionCreators,
	toastSuccessActionCreators,
	languagesActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getLanguages = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_LANGUAGES(payload.queryParams)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(languagesManagerActionCreators.getLanguagesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(languagesManagerActionCreators.getLanguagesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getLanguageDetail = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_LANGUAGE_DETAIL(payload.idLanguage)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(languagesManagerActionCreators.getLanguageDetailSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(languagesManagerActionCreators.getLanguageDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postCreateLanguageDetail = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_CREATE_LANGUAGE_DETAIL()

	const redirectRequest = `${uriList.languages}${uriList.languagesManager}`
	const MsgParams = 'toast__languagesManagement__languageCreate'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(languagesManagerActionCreators.postCreateLanguageDetailSuccess(data.data))

		yield put(languagesActionCreators.getLanguagesEnabled())

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(languagesManagerActionCreators.postCreateLanguageDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postUpdateLanguageDetail = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_UPDATE_LANGUAGE_DETAIL(payload.idLanguage)

	const redirectRequest = `${uriList.languages}${uriList.languagesManager}`
	const MsgParams = 'toast__languagesManagement__languageModify'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(languagesManagerActionCreators.postUpdateLanguageDetailSuccess(data.data))

		yield put(languagesActionCreators.getLanguagesEnabled())

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(languagesManagerActionCreators.postUpdateLanguageDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putLanguageEnabling = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_LANGUAGE_ENABLING(payload.id, payload.enabled)

	const MsgParams = payload.enabled ? 'toast__languagesManagement_languageEnabled' : 'toast__languagesManagement__languageDisabled'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(languagesManagerActionCreators.putLanguageEnablingSuccess(data.data))

		yield put(languagesActionCreators.getLanguagesEnabled())

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(languagesManagerActionCreators.putLanguageEnablingFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_LANGUAGES, getLanguages)
	yield takeLatest(ActionsTypes.GET_LANGUAGE_DETAIL, getLanguageDetail)
	yield takeLatest(ActionsTypes.POST_CREATE_LANGUAGE_DETAIL, postCreateLanguageDetail)
	yield takeLatest(ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL, postUpdateLanguageDetail)
	yield takeLatest(ActionsTypes.PUT_LANGUAGE_ENABLING, putLanguageEnabling)
}

export default sagas
